import { GetterTree } from 'vuex'
import { IRootState, ICouponsState } from '@/@types'
import { isLiveVirtualTrainingCoupon } from '@/helpers/coupons'

const getters: GetterTree<ICouponsState, IRootState> = {
  getCoupon: state => {
    return state?.couponStr ?? ''
  },
  getCouponObj: state => {
    return state?.couponObj ?? null
  },
  getCouponStrStack: state => {
    return state?.couponStrStack ?? null
  },
  getCouponObjStack: state => {
    return state?.couponObjStack ?? null
  },
  isCouponLoading: state => {
    return state?.couponLoading
  },
  getCouponTotalDiscount: state => {
    return state?.couponTotalDiscountCents ?? 0
  },
  is100PercentOffCoupon: state => {
    return (
      state?.couponObj?.discount?.type === 'percent' && state?.couponObj?.discount?.percent === 100
    )
  },
  hasLiveVirtualTrainingCoupon: state => {
    if (state?.couponObjStack?.length) {
      return state.couponObjStack.some(coupon => isLiveVirtualTrainingCoupon(coupon))
    }
    return isLiveVirtualTrainingCoupon(state?.couponObj)
  },
}

export default getters
